import React from 'react';
import { PlantingSeedCalculatorTab } from './PlantingSeedCalculatorTab';

/**
 * Plan-flow shell. Iteration 1: wraps existing Seed Calculator tab.
 * Later: owns Ground → Wizard → Plan → Timing → Growth (handoff §3.3).
 */
export function PlantingPlanFlow({
  selectedPolygons,
  selectedTotal,
  seedOptions,
  fertilizerOptions,
  selectedSeedId,
  selectedFertilizerId,
  onSeedSelect,
  onFertilizerSelect,
  recommendationResult,
  recommendationLoading,
  recommendationError,
  onSaveEstimate,
  onGoToPlots,
  onEditGroup,
  calculatorMode,
  saveEstimateDisabled,
  saveEstimateLoading,
  canExportPdf,
  exportPdfLoading,
  onExportPdf,
  draftGroupName,
  onDraftGroupNameChange,
  draftGroupNote,
  onDraftGroupNoteChange,
  editingZoneLabel,
  editingManualOverride,
  onDraftManualToggle,
  draftZoneCode,
  onDraftZoneCodeChange,
  zoneOptionsList,
  formatZoneOptionLabel,
  optionsLoading,
  draftSoilType,
  onDraftSoilTypeChange,
  soilTypeOptions,
  draftSoilDrainage,
  onDraftSoilDrainageChange,
  soilDrainageOptions,
  draftSoilPh,
  onDraftSoilPhChange,
  phHelperText,
  soilPhGuidanceBlurb,
  draftSoilNotes,
  onDraftSoilNotesChange,
  soilNotePlaceholder,
  optionsError,
  detectZoneLoading,
  detectZoneError,
  onDetectZone,
  editingGroupId,
  saveError,
  onCancelEditGroup,
}) {
  return (
    <div data-testid="planting-plan-flow">
      <PlantingSeedCalculatorTab
        selectedPolygons={selectedPolygons}
        selectedTotal={selectedTotal}
        seedOptions={seedOptions}
        fertilizerOptions={fertilizerOptions}
        selectedSeedId={selectedSeedId}
        selectedFertilizerId={selectedFertilizerId}
        onSeedSelect={onSeedSelect}
        onFertilizerSelect={onFertilizerSelect}
        recommendationResult={recommendationResult}
        recommendationLoading={recommendationLoading}
        recommendationError={recommendationError}
        onSaveEstimate={onSaveEstimate}
        onGoToPlots={onGoToPlots}
        onEditGroup={onEditGroup}
        calculatorMode={calculatorMode}
        saveEstimateDisabled={saveEstimateDisabled}
        saveEstimateLoading={saveEstimateLoading}
        canExportPdf={canExportPdf}
        exportPdfLoading={exportPdfLoading}
        onExportPdf={onExportPdf}
        draftGroupName={draftGroupName}
        onDraftGroupNameChange={onDraftGroupNameChange}
        draftGroupNote={draftGroupNote}
        onDraftGroupNoteChange={onDraftGroupNoteChange}
        editingZoneLabel={editingZoneLabel}
        editingManualOverride={editingManualOverride}
        onDraftManualToggle={onDraftManualToggle}
        draftZoneCode={draftZoneCode}
        onDraftZoneCodeChange={onDraftZoneCodeChange}
        zoneOptionsList={zoneOptionsList}
        formatZoneOptionLabel={formatZoneOptionLabel}
        optionsLoading={optionsLoading}
        draftSoilType={draftSoilType}
        onDraftSoilTypeChange={onDraftSoilTypeChange}
        soilTypeOptions={soilTypeOptions}
        draftSoilDrainage={draftSoilDrainage}
        onDraftSoilDrainageChange={onDraftSoilDrainageChange}
        soilDrainageOptions={soilDrainageOptions}
        draftSoilPh={draftSoilPh}
        onDraftSoilPhChange={onDraftSoilPhChange}
        phHelperText={phHelperText}
        soilPhGuidanceBlurb={soilPhGuidanceBlurb}
        draftSoilNotes={draftSoilNotes}
        onDraftSoilNotesChange={onDraftSoilNotesChange}
        soilNotePlaceholder={soilNotePlaceholder}
        optionsError={optionsError}
        detectZoneLoading={detectZoneLoading}
        detectZoneError={detectZoneError}
        onDetectZone={onDetectZone}
        editingGroupId={editingGroupId}
        saveError={saveError}
        onCancelEditGroup={onCancelEditGroup}
      />
    </div>
  );
}
